import { Radio } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { ManagementSpecCommonCardStore } from "../ManagementSpecCommonCard/ManagementSpecCommonCardStore";
import * as styles from "./SpecEditorVerSwitch.module.less";

type Props = {
  store: ManagementSpecCommonCardStore;
};

type TValue = ManagementSpecCommonCardStore["editorVersion"];

const options: { value: TValue; label: string }[] = [
  { value: "v1", label: "Старая версия" },
  { value: "v2", label: "Новая версия" },
];

export const SpecEditorVerSwitch: React.FC<Props> = observer(({ store }) => (
  <div className={styles.box}>
    <Radio.Group
      size="small"
      buttonStyle="solid"
      optionType="button"
      options={options}
      value={store.editorVersion}
      onChange={(e) => store.changeEditorVersion(e.target.value as TValue)}
    />
  </div>
));
